module.exports = __webpack_public_path__ + "static/img/gl1400-fcm-sdw375bb.894f48e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/gl1400-fcm-sdw375bb.jpg
// module id = itiK
// module chunks = 0